// extracted by mini-css-extract-plugin
export default {"form":"RegisterForm_form__uawLv","actions":"RegisterForm_actions__-0NEO","message_between":"RegisterForm_message_between__d3hPF","agreement":"RegisterForm_agreement__LR6hB"};